const XSMALL_BREAKPOINT = '23rem'
const SMALL_BREAKPOINT = '32rem'
const MEDIUM_BREAKPOINT = '48rem'
const LARGE_BREAKPOINT = '56rem'

export const xsmallAndUp = `@media(min-width: ${XSMALL_BREAKPOINT})`
export const smallAndUp = `@media(min-width: ${SMALL_BREAKPOINT})`
export const mediumAndUp = `@media(min-width: ${MEDIUM_BREAKPOINT})`
export const largeAndUp = `@media(min-width: ${LARGE_BREAKPOINT})`
